//
export default [
  {
    name: 'offer_price',
    type: 'currency-field',
    flex: {
      xs12: true,
    },
    props: {
      label: 'Precio',
    },
  },
]